/* ============================================================
   KaNi Candy - Warenkorb als Klappfenster
   Markup: sections/kani-warenkorb.liquid. Auf- und zugeklappt von
   kani-klapp.js.

   Am Handy Vollbild, ab 760 px als Spalte rechts mit abgedunkelter Seite
   (kani-warenkorb.css). Derselbe Abschnitt, derselbe Inhalt - nur die
   Flaeche ist eine andere. Frueher fuehrte die Tuete am Schreibtisch auf
   die Warenkorbseite; das war ein zweiter, aelter aussehender Warenkorb
   neben diesem.

   Jede Aenderung (Menge, Entfernen, Bestseller dazu) geht an Shopifys
   Warenkorb-API und bestellt im selben Aufruf die neu gerechneten Abschnitte
   mit (Parameter "sections"): den Rumpf dieses Fensters und die Tuete im
   Header samt Zahl. Getauscht wird nur der Inhalt des Rumpfs, nicht das
   Element - sonst liefe dessen Einblend-Animation bei jeder Aenderung neu.
   ============================================================ */
(function(){
  'use strict';
  var fenster = document.getElementById('kani-warenkorb');
  if (!fenster || !window.KaniKlapp) return;

  var WURZEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ABSCHNITTE = 'kani-warenkorb,cart-icon-bubble';
  var rumpf = fenster.querySelector('[data-kani-wk-rumpf]');
  var zahl = fenster.querySelector('[data-kani-wk-zahl]');
  var laeuft = false;

  /* Auf der Warenkorbseite selbst bleibt die Tuete ein Link: dort steht der
     Warenkorb schon, und zwei Ansichten desselben Korbs liefen auseinander. */
  function aufWarenkorbseite(){
    return /\/cart\/?$/.test(window.location.pathname);
  }

  /* ---------- Oeffnen ---------- */
  document.addEventListener('click', function(e){
    var tuete = e.target.closest('#cart-icon-bubble');
    if (!tuete || aufWarenkorbseite()) return;
    e.preventDefault();
    KaniKlapp.oeffnen(fenster, tuete);
    /* Der Korb kann sich seit dem Laden der Seite geaendert haben (Produkt
       hinzugefuegt, zweiter Tab). Einmal frisch holen - das Fenster steht
       dabei schon, der Inhalt wird still ersetzt. */
    neuLaden();
  });

  /* ---------- Abschnitte einsetzen ---------- */
  function einsetzen(abschnitte, nachOben){
    if (!abschnitte) return;
    var html = abschnitte['kani-warenkorb'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neu = doc.querySelector('[data-kani-wk-rumpf]');
      if (neu) {
        var scroll = rumpf.querySelector('.kani-wk__scroll');
        var oben = scroll ? scroll.scrollTop : 0;
        rumpf.innerHTML = neu.innerHTML;
        rumpf.setAttribute('data-anzahl', neu.getAttribute('data-anzahl') || '0');
        if (zahl) zahl.textContent = '(' + (neu.getAttribute('data-anzahl') || '0') + ')';
        scroll = rumpf.querySelector('.kani-wk__scroll');
        if (scroll) scroll.scrollTop = nachOben ? 0 : oben;
      }
    }
    var blase = abschnitte['cart-icon-bubble'];
    var ziel = document.getElementById('cart-icon-bubble');
    if (blase && ziel) {
      var d = new DOMParser().parseFromString(blase, 'text/html');
      var inhalt = d.querySelector('.shopify-section');
      if (inhalt) ziel.innerHTML = inhalt.innerHTML;
    }
  }

  function neuLaden(){
    return fetch(WURZEL + '?sections=' + ABSCHNITTE, { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ if (j && !laeuft) einsetzen(j); })
      .catch(function(){});
  }

  function melden(text){
    var m = rumpf.querySelector('[data-kani-wk-meldung]');
    if (!m) return;
    m.textContent = text;
    m.hidden = !text;
  }

  /* ---------- Aenderungen ---------- */
  function senden(pfad, daten, knopf, nachOben){
    if (laeuft) return;
    laeuft = true;
    rumpf.classList.add('is-laed');
    if (knopf) knopf.classList.add('is-laed');
    daten.sections = ABSCHNITTE;
    daten.sections_url = window.location.pathname;

    fetch(WURZEL + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        laeuft = false;
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Das hat nicht geklappt.');
        einsetzen(res.j.sections, nachOben);
        /* Dawns eigene Bausteine (z. B. die Warenkorbseite in einem zweiten
           Tab, Mengenzaehler) hoeren auf dieses Ereignis. */
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kani-warenkorb' }); } catch (e) {}
        }
      })
      .catch(function(err){
        laeuft = false;
        melden(String(err.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'));
      })
      .then(function(){
        rumpf.classList.remove('is-laed');
        if (knopf) knopf.classList.remove('is-laed');
      });
  }

  fenster.addEventListener('click', function(e){
    var t;
    /* Ab 760 px liegt die abgedunkelte Seite als Pseudoelement auf dem
       Fenster selbst. Ein Klick daneben trifft deshalb das Fenster und kein
       Kind - das ist das Zeichen zum Schliessen. */
    if (e.target === fenster) { KaniKlapp.zurueck(); return; }
    if ((t = e.target.closest('[data-kani-wk-menge]'))) {
      senden('cart/change.js', {
        id: t.getAttribute('data-key'),
        quantity: Math.max(0, parseInt(t.getAttribute('data-kani-wk-menge'), 10) || 0)
      });
      return;
    }
    if ((t = e.target.closest('[data-kani-wk-weg]'))) {
      /* Eine Mischung besteht aus mehreren Zeilen - alle auf einmal auf 0. */
      var updates = {};
      t.getAttribute('data-kani-wk-weg').split(',').forEach(function(k){ if (k) updates[k] = 0; });
      senden('cart/update.js', { updates: updates });
      return;
    }
    if ((t = e.target.closest('[data-kani-wk-dazu]'))) {
      senden('cart/add.js', {
        items: [{ id: parseInt(t.getAttribute('data-kani-wk-dazu'), 10), quantity: 1 }]
      }, t, true); /* nach oben: der neue Artikel steht ganz oben */
    }
  });
})();
